const economicallyInactiveStatus = [
  'HOUSE PERSON',
  'UNEMPLOYED',
  'RETIRED',
  'LONG TERM DISABLED',
  'STUDENT'
];

const industryRequiredStatus = [
  'FULL TIME',
  'PART TIME',
  'SELF EMPLOYED',
  'AGENCY CONTRACT',
  'FIXED TERM CONTRACT'
];

export function isEconomicallyInactive(employmentStatus) {
  return economicallyInactiveStatus.includes(employmentStatus);
}

export function isIndustryRequired(employmentStatus, otherEmploymentStatus) {
  return otherEmploymentStatus && otherEmploymentStatus === 'SELF EMPLOYED'
    ? true
    : industryRequiredStatus.includes(employmentStatus);
}
